namespace SPA
{
	export namespace BRW
	{
		export class Exeption
		{

			public constructor( errorCode: string  )
			{
				let errorMessage = '';

				switch ( parseInt( errorCode, 10 ) )
				{
					case 30000:
					{
						errorMessage = app.getMessage( 'BRW.GENERAL.REST_ERROR.' + errorCode );
						break;
					}
				}

				if ( !errorMessage )
				{
					errorMessage = app.getMessage( 'BRW.GENERAL.REST_ERROR.rest_default' );
				}

				app.addNotify(
				{
					body: [ ui.text( errorMessage ) ],
					context: 'danger',
					timeout: 7500,
					title: [ ui.h( 4, app.getMessage( 'BRW.GENERAL.ERROR.title' ) ) ],
				});
			}

		}
	}
}
